import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators, FormControl} from '@angular/forms';
import {ResultCardComponent} from "../check-iban/result-card/result-card.component";
import {MessagesService} from "../../services/messages.service";
import {SmsSenderRequest} from "../../../model/requests/SmsSenderRequest";
import {SmsSenderService} from "../../../api/smsSenderService";

@Component({
  selector: 'app-sms-sender',
  templateUrl: './sms-sender.component.html',
  styleUrls: ['./sms-sender.component.scss'],
  providers: [ResultCardComponent]
})
export class SmsSenderComponent implements OnInit {
  smsForm: FormGroup = new FormGroup({})
  isCustomText: boolean = false;
  isLiquidatarioDisabled = false;
  dynamicFields: string[] = [];
  smsTextOptions: { label: string, value: string }[] = [];

  constructor(private fb: FormBuilder, private smsSenderService: SmsSenderService, private messagesService: MessagesService) {
  }

  ngOnInit() {
    // Inizializza il form con i campi fissi
    this.smsForm = this.fb.group({
      telefonoCliente: ['', [Validators.required, Validators.pattern(/^[0-9]*$/)]],
      telefonoLiquidatore: ['', [Validators.required, Validators.pattern(/^[0-9]*\.?[0-9]*$/)]],      //numeri e massimo un punto per separare
      emailLiquidatore: ['', [Validators.email]],
      smsText: ['', Validators.required],
      customText: ['', Validators.maxLength(160)],
      customTextCheckBox: [false],
      numeroSinistro: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]+\/[a-zA-Z0-9]+\/[a-zA-Z0-9]+$/)]]
    });

    this.smsSenderService.functionGetConfigSms().then(response => {
      if (response != undefined && response.status === "200") {
        if (response.phone !== "unknown") {
          this.smsForm.get('telefonoLiquidatore')?.setValue(response.phone);
          this.isLiquidatarioDisabled = true;
        }
        if(response.emailLiquidatore !== "" || response.emailLiquidatore !== "unknown"){
          this.smsForm.get('emailLiquidatore')?.setValue(response.emailLiquidatore);
        }
        this.smsTextOptions = response.sms.map((smsText: string) => ({
          label: smsText,
          value: smsText
        }));
      } else {
        this.messagesService.addMessage({text: "Errore durante il recupero della configurazione", type: "error"});
      }
    });


    // Rileva i cambiamenti al campo smsText per aggiornare i campi dinamici
    this.smsForm.get('smsText')?.valueChanges.subscribe((value) => {
      this.updateDynamicFields(value);
    });
  }

// Funzione per sanitizzare il nome del campo
  sanitizeFieldName(name: string): string {
    return name.replace(/[\.\s]/g, ''); // Rimuove punti e spazi
  }

  updateDynamicFields(selectedText: string) {
    const placeholderRegex = /\[(.*?)\]/g;
    this.dynamicFields = [];  // Reset dei campi dinamici

    let match;
    while ((match = placeholderRegex.exec(selectedText)) !== null) {
      const originalFieldName = match[1]; // Nome originale con punti e spazi
      const sanitizedFieldName = this.sanitizeFieldName(originalFieldName); // Nome sanitizzato per formControlName


      if (!this.smsForm.contains(sanitizedFieldName)) {
        this.dynamicFields.push(originalFieldName); // Per gestire l'interfaccia utente
        this.smsForm.addControl(sanitizedFieldName, new FormControl('', Validators.required));
      }
    }

    // Rimuovi i controlli non necessari
    Object.keys(this.smsForm.controls).forEach(controlName => {
      const unsanitizedNames = this.dynamicFields.map(name => this.sanitizeFieldName(name));
      if (!['telefonoCliente', 'telefonoLiquidatore', 'smsText', 'customText', 'customTextCheckBox', 'numeroSinistro', 'emailLiquidatore'].includes(controlName) && !unsanitizedNames.includes(controlName)) {
        this.smsForm.removeControl(controlName);
      }
    });
  }

  toggleCustomText() {
    this.isCustomText = !this.isCustomText;
    const smsTextControl = this.smsForm.get('smsText');
    const customTextControl = this.smsForm.get('customText');

    if (this.isCustomText) {
      smsTextControl?.disable();
      this.dynamicFields = []
      customTextControl?.enable();
    } else {
      smsTextControl?.enable();
      customTextControl?.disable();
    }
  }


  onSinistroChange () {
    const sinistro = this.smsForm.get('numeroSinistro')?.value;
    if(sinistro !== null && sinistro !== undefined && (sinistro.length == 3 || sinistro.length == 8 )){
      this.smsForm.get('numeroSinistro')?.setValue(sinistro + "/");
    }
  }

  async sendSms() {
    if (this.smsForm.invalid) {
      this.messagesService.addMessage({text: "Errori nella compilazione del form", type: "error"});
      Object.keys(this.smsForm.controls).forEach((key) => {
        const controlErrors = this.smsForm.get(key)?.errors;
        if (controlErrors) {
          if (controlErrors['required']) {
            this.messagesService.addMessage({text: `Campo obbligatorio mancante`, type: "error"});
          } else if (controlErrors['pattern']) {
            this.messagesService.addMessage({text: `Presenti caratteri non validi.`, type: "error"});
          }
        }
      });
      return;
    }

    let message = this.smsForm.value.smsText;
    //se il testo non è custom, quindi è una frase predefinita, sostituisco i placeholder con i valori dei campi
    if (!this.isCustomText) {
      message = this.replacePlaceholders(message);

    } else {
      //se il testo è custom, aggiungo le informazioni in testa e in coda
      message = this.smsForm.value.customText;
      message = this.aggiungiInfoInTesta(message)
      message = this.aggiungiInfoInCoda(message)
    }

    const smsData: SmsSenderRequest = {
      telefonoCliente: this.smsForm.value.telefonoCliente,
      telefonoLiquidatore: this.smsForm.value.telefonoLiquidatore,
      numeroSinistro: this.smsForm.value.numeroSinistro,
      messaggio: message,
      emailLiquidatore: this.smsForm.value.emailLiquidatore,
    };

    await this.smsSenderService.functionSmsSend(smsData)
      .then(response => {
        if (response != undefined && response.status === "200") {
          this.messagesService.addMessage({text: "SMS inviato con successo", type: "success"});
        } else {
          this.messagesService.addMessage({text: "Errore durante l'invio dell'SMS", type: "error"});
        }
      }).catch(() => {
        this.messagesService.addMessage({text: "Errore inatteso del servizio", type: "error"})
      });
  }

  replacePlaceholders(text: string) {
    return text.replace(/\[(.*?)\]/g, (_, fieldName) => {
      const sanitizedFieldName = this.sanitizeFieldName(fieldName);  // Sanitizza il nome
      return this.smsForm.get(sanitizedFieldName)?.value || '';
    });
  }

  aggiungiInfoInCoda(message: string) {
    return `${message} -  Per eventuali chiarimenti richiamare il n. ${this.smsForm.value.telefonoLiquidatore} oppure scrivere una mail a ${this.smsForm.value.emailLiquidatore}`;
  }

  aggiungiInfoInTesta(message: string) {
    return "Sinistro n. " +
      this.smsForm.value.numeroSinistro + " - " +
      message;
  }


}
